import React from 'react';
import { connect } from 'react-redux';
import { getAuthState, getOnboardingState } from '../../store/selectors';
import { getCareerDetails, getDegreeDetails } from '../../store/actions';
import Chevron from '../user-dashboard/utility/Chevron';
import SunIcon from '../utility/SunIcon';
import Loading from '../utility/Loading';
import CareerDetails from './CareerDetails';
import DegreeDetails from './DegreeDetails';
import { careersDegreesTab as copy } from '../../copy/advisor-dashboard/careers-degrees-tab.json';

export class CareerDegreeBarDropdown extends React.Component {
  _isMounted = false;

  constructor(props) {
    super(props);
    this.state = {
      details: {},
      showDropdown: false,
      showAllDegrees: false,
      isLoading: false,
    };
  }

  borderLeft = {
    borderLeft: `9px solid ${this.props.chosenTenant.secondary}`,
  };

  secondaryBorder = {
    border: `1px solid ${this.props.chosenTenant.secondary}`,
  };

  hide = {
    height: '1.9em',
    overflow: 'hidden',
  };

  brightOutlook = {
    height: '21px',
    width: '21px',
    color: 'yellow',
  };

  toggleShowDropdown = (val) => {
    this.setState({
      showDropdown: val,
    });
  };

  handleClick = async () => {
    const { details, showDropdown } = this.state;
    if (Object.keys(details).length === 0) {
      this.setState(
        {
          isLoading: true,
        },
        async () => {
          let detailsResponse = [];
          if (this.props.careerOrDegree === 'careers') {
            detailsResponse = await this.props.getCareerDetails(
              this.props.data.id
            );
          } else if (this.props.careerOrDegree === 'degrees') {
            detailsResponse = await this.props.getDegreeDetails(
              this.props.data.id
            );
          }
          this.setState({
            details: detailsResponse,
            showDropdown: !showDropdown,
            isLoading: false,
          });
        }
      );
    } else {
      this.setState({
        showDropdown: !showDropdown,
      });
    }
  };

  handleShowHideDegrees = (val) => {
    this.setState({
      showAllDegrees: !val,
    });
  };

  render() {
    const { data } = this.props;
    const { showDropdown, details, showAllDegrees, isLoading } = this.state;
    return (
      <div
        className="details-dropdown"
        id="details-dropdown"
        style={this.borderLeft}
      >
        <button
          type="button"
          tabIndex={0}
          className="details-dropdown__header"
          onClick={this.handleClick}
        >
          <div className="details-dropdown__title-and-sun">
            <span className="details-dropdown__title">{data.titleEn}</span>
            {data?.academicProgramTypeEn && (
              <div className="details-dropdown__black-box">
                {data.academicProgramTypeEn}
              </div>
            )}
            {data?.outlook?.length > 0 && <SunIcon />}
          </div>
          <Chevron
            transform={showDropdown ? 'rotate(270deg)' : 'rotate(90deg)'}
          />
        </button>
        {showDropdown && isLoading && <Loading height="100%" />}
        {showDropdown && Object.keys(details).length > 0 && !isLoading && (
          <div className="details-dropdown__body">
            <p className="details-dropdown__body-header">
              {`
              ${this.props.careerOrDegree === 'careers' ? 'Career ' : 'Degree '}
              ${copy.details}`}
            </p>
            <div className="details-dropdown__mapped-degrees-section">
              <p className="details-dropdown__details-header">
                {`
                ${copy.mapped}
                ${
                  this.props.careerOrDegree === 'careers'
                    ? ' Degrees'
                    : ' Careers'
                }:`}
              </p>
              <div
                className="details-dropdown__mapped-degrees-container"
                style={showAllDegrees ? null : this.hide}
              >
                {!details.mapped ? (
                  <p className="details-dropdown__no-degrees">{copy.none}</p>
                ) : (
                  <>
                    {details.mapped.map((degree) => (
                      <p
                        className="details-dropdown__mapped-degree"
                        key={`${degree.id}`}
                        style={this.secondaryBorder}
                      >
                        {degree.titleEn}
                      </p>
                    ))}
                  </>
                )}
              </div>
              {!!details.mapped && (
                <button
                  type="button"
                  className="details-dropdown__hide-show-degrees"
                  onClick={() => {
                    this.handleShowHideDegrees(showAllDegrees);
                  }}
                >
                  {showAllDegrees ? 'Collapse' : 'Expand'}
                </button>
              )}
            </div>
            {this.props.careerOrDegree === 'careers' && (
              <CareerDetails details={details} />
            )}
            {this.props.careerOrDegree === 'degrees' && (
              <DegreeDetails
                details={details}
                showEditButton={
                  data.academicProgramTypeEn === "Bachelor's" &&
                  this.props.chosenTenant.features.includes('highschool') &&
                  (this.props.advisorRole === 'Super User' ||
                    this.props.advisorRole === 'Tenant Admin')
                }
                chosenTenant={this.props.chosenTenant}
              />
            )}
          </div>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  const auth = getAuthState(state);
  const advisorRole = getOnboardingState(state).userData.user.role;
  return { auth, advisorRole };
}

export default connect(mapStateToProps, { getCareerDetails, getDegreeDetails })(
  CareerDegreeBarDropdown
);
